import { render } from "./TextTalkInput.vue?vue&type=template&id=ea51355e&scoped=true"
import script from "./TextTalkInput.vue?vue&type=script&lang=js"
export * from "./TextTalkInput.vue?vue&type=script&lang=js"

import "./TextTalkInput.vue?vue&type=style&index=0&id=ea51355e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea51355e"]])

export default __exports__